import { format, parseISO } from "date-fns";
import { nl } from "date-fns/locale";

import type { LeaveStatus } from "../types/api";

export const statusLabels: Record<LeaveStatus, string> = {
  draft: "Concept",
  requested: "Aangevraagd",
  needs_info: "Toelichting nodig",
  approved: "Goedgekeurd",
  rejected: "Afgewezen",
  cancelled: "Geannuleerd",
};

export function formatDate(value: string, pattern = "dd-MM-yyyy") {
  return format(parseISO(value), pattern, { locale: nl });
}

export function formatMinutes(minutes: number) {
  const hours = minutes / 60;
  return `${new Intl.NumberFormat("nl-NL", {
    maximumFractionDigits: 2,
  }).format(hours)} uur`;
}

export function formatCurrency(value: string | number | null, currency = "EUR") {
  if (value === null) return "Op aanvraag";
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency,
  }).format(Number(value));
}

export function organizationQuery(organizationId: number | null) {
  return organizationId ? `organization=${organizationId}` : "";
}
